/**
 * useAppLogin - App uses built-in login dialog instead of Drupal login form
 */
export const useAppLogin = (process.env.NODE_ENV_LOGIN && Boolean(process.env.NODE_ENV_LOGIN)) || false;
